<div class="editor-wrapper">

  <!-- Toolbar -->
  <div class="editor-header">
    <button class="code-btn" (click)="toggleCodeView()">
      {{ isCodeView ? 'Visual Mode' : 'HTML Mode' }}
    </button>
  </div>

  <!-- Visual Editor Mode -->
  <div *ngIf="!isCodeView" class="editor-container">
    <quill-editor
      [(ngModel)]="content"
      [modules]="modules"
      (onContentChanged)="onContentChanged($event)"
      theme="snow"
      class="pro-editor"
    ></quill-editor>
  </div>
  <div *ngIf="isCodeView" [innerHTML]="content" ></div>
</div>
